<template>
  <div id="landing" class="home"> 

    
    <div class="content-wrapper">
      <div id="landing-header" class="content content-wide flex flex-sb-c" style="height:5rem">
          <AppLogo />
          <div>
            <AppButton v-if="store.user.state.user.guest" color="primary" @click="signIn"><span class="no-mobile">Opret bruger / </span>Log ind</AppButton>
          </div>
      </div>
    </div>

    <AppHero />

    <app-content size="wide">


    <div id="features">
      <div class="feature">
        <div>
          <img src="@/assets/img/landing/feature_import.svg" />
        </div>
        <div>
          <h4>Importér fra Excel</h4>
          <p>Importér stop fra Excel eller Google sheets</p>
        </div>
      </div>
      <div class="feature">
        <div>
          <img src="@/assets/img/landing/feature_optimize.svg" />
        </div>
        <div>
          <h4>Optimer din rute</h4>
          <p>Tripply beregner den hurtigste rute mellem dine stop, så du får mere tid til det du skal.</p>
        </div>
      </div>
      <div class="feature">
        <div>
          <img src="@/assets/img/landing/feature_breaks.svg" />
        </div>
        <div>
          <h4>Præcise køretider</h4>
          <p>Tripply beregner ruten ud fra en gennemsnitlig vogns kørsel. Vi understøtter også bil-ruter.</p>
        </div>
      </div>
      <div class="feature">
        <div>
          <img src="@/assets/img/landing/feature_breaks.svg" />
        </div>
        <div>
          <h4>Automatiske pauser</h4>
          <p>Angiv hvor længe ruten må vare, så fordeler Tripply pauserne</p>
        </div>
      </div>
      <div class="feature">
        <div>
          <img src="@/assets/img/landing/feature_live.svg" />
        </div>
        <div>
          <h4>Live ruter <span class="plan-tag">PLUS</span></h4>
          <p>Lad venner, familie eller kollegaer følge ruten direkte og se forventede ankomsttider i realtid.</p>
        </div>
      </div>
      <div class="feature">
        <div>
          <img src="@/assets/img/landing/feature_timetable.svg" />
        </div>
        <div>
          <h4>Opret tidsplan</h4>
          <p>Når ruten er finpudset kan I oprette en overskuelig tidsplan, som kan medbringes på vognen.</p>
        </div>
      </div>
      <div class="feature">
        <div>
          <img src="@/assets/img/landing/feature_stops.svg" />
        </div>
        <div>
          <h4>Op til 100 stop <span class="plan-tag">PLUS</span></h4>
          <p>Med Tripply Free kan du oprette op til 35 stop i én samlet ruteplan.</p>
        </div>
      </div>
    </div>

    <section>
      <h1 class="text-c">Få mere med Plus</h1>
      <SubscriptionPlans class="flex-c" />
    </section>

    <div id="stats">
      <div>Vi har hjulpet <span>7301+ brugere</span> med at planlægge <span>12.100+ ruter</span></div>
    </div>

    </app-content>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'

import AppLogo from '@/components/atoms/AppLogo.vue'
import AppHero from '@/components/home/AppHero.vue'
import AppContent from '@/components/layout/AppContent.vue'

import SubscriptionPlans from '@/components/subscription/SubscriptionPlans.vue'

import { store } from '@/store'

export default defineComponent({
  name: 'Home',
  components: { AppLogo, AppHero, AppContent, SubscriptionPlans },
  setup() {
    const theme = computed(() => store.global.state.theme)
    const routes = store.route.state

    const vehicle = ref('truck')

    function signIn() {
      store.modal.showModal('SignIn')
    }

    return { store, signIn, theme, routes, vehicle }
  }
})
</script>

<style lang="scss" scoped>
#landing {
  h1 {
    font-size: 2rem;
    font-weight: bold;
  }

  #features {
    margin: 0 0;
    display: grid;
    grid-gap: 2rem 2rem;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));

    .feature {
      display: flex;
      h4, p {
        margin: 0;
      }
      h4 {
        margin: .5rem 0 .5rem;
      }
      p {
        font-size: 15px;
        opacity: 0.6;
      }
      img {
        width: 6rem;
        margin-right: 1rem;
      }
    }
  }

  #stats {
    display:flex;
    justify-content: center;
    margin: 4rem 0 2rem;
    div {
      background: var(--color-divider);
      padding: 1.25rem 1rem 1.25rem 2rem;
      border-radius: 4rem;
    }
    span {
      background: var(--color-primary);
      color: var(--color-on-primary);
      padding: .75rem 1rem;
      border-radius: 2rem;
      font-weight: bold;
      font-size: 1.25rem;
      margin: 0 .5rem;
      white-space: nowrap;
      line-height: 4rem;
    }
  }
}




</style>
